export function request(userId, legUid, data) {
    console.info('updateLeg userId, leg', {userId, legUid, data});

    return {
        type: 'BETSLIP_UPDATE_LEG',
        userId,
        legUid,
        data
    };
}

export function bulkUpdateBets( userId, stake ) {
    return {
        type: 'BETSLIP_BULK_UPDATE_LEG',
        userId,
        stake
    };
}
